
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const preBX: IProductData = {
  id: "popeaudio-prebx",
  name: "Pre-BX",
  description: "Class A/B mic preamp with vintage character and integrated BAX EQ.",
  specialOrder: true,
  images: ["/img/popeaudio_prebx_front.jpg", "/img/popeaudio_prebx_side.jpg"],
  details: [{
    label: "Description",
    markdown: `
Pope Audio PRE-BX Mic Preamp is a versatile 500 series microphone preamp that packs a powerful punch and features a unique approach to EQ.  
For his first mic pre design, Pope Audio designer and founder Adam Pope found inspiration in the classic American console. The Pre-BX features a padless input stage topology, which utilizes a 2520 style opamp and 2622 input transformer.  
This transformer is switchable between 600R and 150R to help accommodate low impedance microphones.  

The output stage of the Pre-BX goes in a slightly different direction.  
It features another 2520 style amp, but then uses a Carnhill quad transformer (as used on Neve products).  
This design choice will give smoother, less “in your face” sounds while still allowing for a subtle presence.  

Pope Audio also includes a switch for lowering your output level by a ratio of 3:1.  
Simply flip the switch from 1:1 to 3:1 and you can drive the preamp circuitry for added saturation and color without overloading anything.  

For the EQ section of the Pre-BX, Pope Audio is once again employing a Baxandall EQ.  
These simple controls feature a Hi and Lo band with very gentle slopes that start at 20KHz and 20Hz respectively.  
On the Pre-BX, the gains are about ±7 dB, so you can’t do too much wrong!  

The Pre-BX features a combo switch on the front of the unit for easy patching with either XLR or Hi-Z.  
And with its robust and durable construction, the PRE-BX is built to withstand the rigors of professional use, ensuring that it will be a staple in your recording setup for years to come.  
`
  }, {
    label: "Features",
    markdown: `
- Integrated Baxandall EQ (20Hz – 20kHz @ -/+7dB approx)
- Fully analogue signal path with approx 60dB mic gain
- Carnhill output transformer with 3:1 attenuator
- API-style input transformer
- Alternative front-panel mic/hi-Z input
- Phase Switch
- Hand-built in the UK
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.popeaudio.co.uk/general-1" target="_blank">https://www.popeaudio.co.uk/general-1</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/tD-C5boDa8o?si=kY8e7CfT4LfS_sdY"],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.SINGLE_SLOT, HASHTAGS.API_500, HASHTAGS.MASTERING],
    manufacturer: BRAND.POPE_AUDIO,
  }
}